<template>
  <a-spin tip="导出PNG中..." :spinning="spinning">
    <div class="spine-wrapper">
      <div class="header">
        <div class="logo" @click="goHome">
          <span class="icon-logo icon-img_logo_142_26"></span>
        </div>
        <div class="action">
          <a-button type="primary" @click="showExport">导出</a-button>

        </div>
      </div>
      <div class="editor-box">
        <div class="left-side">
          <div class="bone">
            <p class="title">骨骼</p>
            <div class="bone_list">
              <div class="empty">
                <span class="icon-icon_suo_24"></span>
              </div>
            </div>
          </div>
          <div class="action">
            <div class="title">原图切片</div>
            <div class="nav">
              <div class="nav-item">正：<span v-if="packageInfo.front_view"><img v-if="packageInfo.front_view.preview_img" :src="`${constv.QINIU_IMAGE_CND_URL}${packageInfo.front_view.preview_img}`" alt="" srcset=""></span></div>
              <div class="nav-item">侧：<span v-if="packageInfo.side_view"><img v-if="packageInfo.side_view.preview_img" :src="`${constv.QINIU_IMAGE_CND_URL}${packageInfo.side_view.preview_img}`" alt="" srcset=""></span></div>
              <div class="nav-item">背：<span v-if="packageInfo.back_view"><img v-if="packageInfo.back_view.preview_img" :src="`${constv.QINIU_IMAGE_CND_URL}${packageInfo.back_view.preview_img}`" alt="" srcset=""></span></div>
            </div>
            <div class="action_list">
              <div class="empty">
                <span class="icon-icon_suo_24"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="editor">
          <div id="spine"></div>
        </div>
        <div class="right-side">
          <h2 class="title">动作库</h2>
          <div class="direction-list">
            <span :class="{'active': activeDirection == key, 'disabled': value.list.length<=0}" v-for="(value,key) in direction" :key="value.name" @click="chooseDirection(key)">{{ value.name }}</span>
          </div>
          <div class="action-list" v-if="direction[activeDirection].list.length > 0">

            <div class="action-item" :class="{active: direction[activeDirection].activeAction === index}" v-for="(item, index) in direction[activeDirection].list" :key="index" @click="chooseAction(index)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <export-png-modal ref="exportPngModal" :image="imageData" @exportImage="exportImage"></export-png-modal>
  </a-spin>

</template>

<script>
import exportPngModal from '@/components/Zpace/modal/exportPngModal'
// import { ColorOverlayFilter } from '@pixi/filter-color-overlay'
import { dataURLtoBlobs } from '@/utils/util'
// const _ = require('lodash')
const PIXI = window.PIXI
export default {
  name: 'Spine',
  components: {
    exportPngModal
  },
  data () {
    return {
      startX: '',
      startY: '',
      boneX: '',
      boneY: '',
      isMove: '',
      activeBone: {},
      scale: 1,
      init_data: {
        x: 400,
        y: 600,
        scale: 0.25,
        stageWidth: 0,
        stageHeight: 0
      },
      app: {},
      personContain: {},
      bgContain: {},
      areaContain: {},
      uploadPlaceList: [],
      Model: {},
      activeSlot: {},
      activeDirection: 'front_view',
      direction: {
        'front_view': {
          name: '正面',
          activeAction: 0,
          list: [] },
        'back_view': { name: '侧面', activeAction: 0, list: [] },
        'side_view': { name: '背面', activeAction: 0, list: [] }
      },
      p_x: '',
      p_y: '',
      pStart_x: '',
      pStart_y: '',
      package_id: this.$route.query.id,
      packageInfo: {},
      spinning: false,
      slicesList: {},
      personRect: {},
      modelContain: {},
      showExportModal: false,
      imageData: ''
    }
  },

  created () {

  },
  mounted () {
    this.init_data.stageWidth = document.querySelector('.editor').clientWidth
    this.init_data.stageHeight = document.querySelector('.editor').clientHeight
    this.init_data.x = this.init_data.stageWidth / 2
    this.init()
  },
  methods: {
    /** spine交互  开始 */
    // 资源初始化
    init () {
      const app = new PIXI.Application(
        {
          width: this.init_data.stageWidth,
          height: this.init_data.stageHeight,
          autoResize: true,
          antialias: true,
          transparent: true,
          resolution: window.devicePixelRatio || 1,
          resizeTo: document.querySelector('.editor')
        }
      )
      // 最大的容器
      this.contentContain = new PIXI.Container()
      // 人物容器
      this.personContain = new PIXI.Container()
      // 背景容器
      this.bgContain = new PIXI.Container()

      this.contentContain.width = this.init_data.stageWidth
      this.contentContain.height = this.init_data.stageHeight
      this.contentContain.pivot.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)
      this.contentContain.position.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)
      this.contentContain.addChild(this.personContain)
      this.app = app

      this.app.renderer.resize(document.querySelector('.editor').clientWidth, document.querySelector('.editor').clientHeight)
      document.querySelector('#spine').appendChild(app.view)
      this.app.stage.interactive = true
      this.app.stage.buttonMode = true
      this.app.loader.add('model', 'spineAssets/luomo/luomo.json').add('circle', 'img/circle.png').add('chuman_head', 'img/lx-1.png').load(this.resLoadHandler)
      this.app.stage.addChild(this.bgContain)
      this.app.stage.addChild(this.contentContain)

      window.addEventListener('resize', this.resize, false)
    },
    resize () {
      this.app.resize(document.querySelector('.editor'))
      this.init_data.stageWidth = document.querySelector('.editor').clientWidth
      this.init_data.stageHeight = document.querySelector('.editor').clientHeight
      this.personContain.position.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)

      this.loadBg()
    },
    resLoadHandler (loader, resources) {
      this.Model = new PIXI.spine.Spine(resources.model.spineData)

      this.direction[this.activeDirection].list = this.Model.spineData.animations.map(item => { return { name: item.name } })
      // 默认播放第一次动作
      console.log(this.Model, 'model')

      // 设置默认皮肤
      // this.Model.skeleton.setSkinByName('default')
      // this.Model.skeleton.setSlotsToSetupPose()
      this.loadBg()
      this.loadModel()
      this.loadPackage()
      this.eventInit()
      // this.loadBone()
      // this.debug()
    },
    // 获取素材信息
    async loadPackage () {
      if (this.package_id) {
        const params = {
          id: this.package_id
        }
        const res = await this.$api.texture.getCharacterInfo(params)

        if (res.status === 'ok') {
          this.packageInfo = res.data
          this.loadSlices(this.packageInfo[this.activeDirection].elements_path)
        }
      } else {
        this.$message.error('素材id非法')
        this.$router.push('/manage/person')
      }
    },
    // 获取素材信息
    loadHead () {
      const head = new PIXI.Sprite(
        this.app.loader.resources['chuman_head'].texture
      )

      this.areaContain.width = 512
      this.areaContain.height = 512
      head.width = 49
      head.height = 60
      head.x = 232
      head.y = 74
      // this.areaContain.pivot.set(256, 256)
      this.areaContain.position.set(0, 0)
      this.areaContain.addChild(head)
    },
    // 加载切片
    async loadSlices (elementPath) {
      this.$third.get(`${this.constv.QINIU_IMAGE_CND_URL}` + elementPath).then(res => {
        this.slicesList = res.data
        for (const key in res.data) {
          this.app.loader.add(key, this.constv.QINIU_IMAGE_CND_URL + res.data[key])
        }
        this.app.loader.load((loader, resources) => {
          this.hackTextureBySlotName(res.data)
        })
      })
    },
    // 根据插槽 替换 纹理
    hackTextureBySlotName (list) {
      for (const name in list) {
        const texture = this.app.loader.resources[name].texture
        if (this.Model.skeleton.findSlot(name) && this.Model.skeleton.findSlot(name).attachment) {
          this.Model.hackTextureBySlotName(name, texture, { width: texture.width, height: texture.height })
        } else {
          console.log(this.Model.skeleton.findSlot(name), name, 'name')
        }
      }
    },
    // 加载背景网格
    loadBg () {
      this.bgContain.removeChild()
      for (var x = 0.5; x < 1920; x += 55) {
        const ctx = new PIXI.Graphics()
        ctx.lineStyle(1, 0x999999, 1)
        ctx.moveTo(x, 0)
        ctx.lineTo(x, 1080)
        this.bgContain.addChild(ctx)
      }
      for (var y = 0.5; y < 1080; y += 55) {
        const ctx = new PIXI.Graphics()
        ctx.lineStyle(1, 0x999999, 1)
        ctx.moveTo(0, y)
        ctx.lineTo(1920, y)
        this.bgContain.addChild(ctx)
      }
      this.bgContain.width = 1920
      this.bgContain.height = 1080
      this.bgContain.pivot.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)
      this.bgContain.position.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)
    },
    // 加载初始模型
    loadModel () {
      this.Model.x = 0
      this.Model.y = 0
      // 模型原点有问题， 设置为左上角原点
      this.Model.pivot.set(-this.Model.spineData.width / 2, -this.Model.spineData.height)
      // 开启debug
      // this.Model.drawDebug = true
      // this.Model.drawBones = true
      this.personContain.width = this.Model.spineData.width
      this.personContain.height = this.Model.spineData.height
      this.personContain.addChild(this.Model)
      // 设置最外部容器原点为骨骼数据的宽高中点
      this.personContain.pivot.set(this.Model.spineData.width / 2, this.Model.spineData.height / 2)
      // 设置最外部容器 的位置 居中显示
      this.personContain.position.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)

      this.personContain.scale.set(this.init_data.scale)
      // this.debug()
      this.personContain.interactive = true
    },
    // 模型事件初始化
    eventInit () {
      // 模型拖拽
      this.personContain
        .on('pointerdown', e => {
          const currentTarget = e.currentTarget
          const { x, y } = e.data.global
          currentTarget.dragging = true
          this.p_x = x
          this.p_y = y
          this.pStart_x = currentTarget.x
          this.pStart_y = currentTarget.y
        })
        .on('pointermove', e => {
          const { x, y } = e.data.global
          const currentTarget = e.currentTarget
          if (currentTarget.dragging) {
            currentTarget.x = x - this.p_x + this.pStart_x
            currentTarget.y = y - this.p_y + this.pStart_y
          }
        })
        .on('pointerupoutside', (e) => {
          this.pointerupoutside(e)
        })
        .on('pointerup', (e) => {
          this.pointerupoutside(e)
        })
      // 监听滚轮放大缩小
      document.querySelector('#spine').addEventListener('mousewheel', (event) => {
        let zoom = (event.deltaY > 0 ? -0.1 : 0.1) + this.scale
        zoom = Math.max(1, zoom) // 最小为原来的1/10
        zoom = Math.min(3, zoom) // 最大是原来的3倍
        this.scale = zoom
        this.contentContain.scale.set(this.scale)
        this.bgContain.scale.set(this.scale)
      })
    },
    // 加载可拖拽骨骼
    loadBone () {
      const bones = []
      // 遍历骨骼
      for (let i = 0; i < this.Model.skeleton.bones.length; i++) {
        if (this.Model.skeleton.bones[i].data.name.indexOf('Ctrl') != -1) {
          const item = this.Model.skeleton.bones[i]
          bones.push(item)
          const sprite = new PIXI.Sprite(
            this.app.loader.resources['circle'].texture
          )

          const circleX = this.Model.width / 2 + item.worldX
          const circleY = this.Model.height + item.worldY
          sprite.width = 50
          sprite.height = 50

          // 设置精灵图中心点为坐标起点
          sprite.anchor.set(0.5)
          sprite.x = circleX
          sprite.y = circleY
          // 设置成可点击的
          sprite.interactive = true
          sprite.buttonMode = true
          // sprite.filters = [new OutlineFilter(2, 0x99ff99)]
          this.personContain.addChild(sprite)
          sprite.on('pointerdown', (e) => {
            this.pointerdown(e, item)
          })
            .on('pointermove', (e) => {
              this.pointermove(e)
            })
            .on('pointerupoutside', (e) => {
              this.pointerupoutside(e)
            })
            .on('pointerup', (e) => {
              this.pointerupoutside(e)
            })
        }
      }
    },
    debug () {
      console.log(this.personContain)
      this.personContain.removeChild(this.personRect)
      this.personRect = new PIXI.Graphics()
      let { width, height } = this.personContain
      width = width / this.init_data.scale
      height = height / this.init_data.scale
      this.personRect.lineStyle(2, 0xff7500, 1)
      // ctx.beginFill(0xFF700B, 1)
      this.personRect.drawRect(0, 0, width, height)

      // ctx.pivot.set(_width / 2, _height / 2)

      this.personContain.addChild(this.personRect)

      // this.personContain.filters = [new ColorOverlayFilter(1, 0x99ff99)]
    },
    pointerdown (e, item) {
      this.personContain.interactive = false

      const currentTarget = e.currentTarget
      const { x, y } = e.data.global

      currentTarget.dragging = true
      currentTarget.alpha = 0.5
      this.activeBone = item
      this.startY = y
      this.startX = x
      this.boneX = item.x
      this.boneY = item.y
    },
    pointerupoutside (e) {
      const currentTarget = e.currentTarget
      currentTarget.alpha = 1
      currentTarget.dragging = false
      this.personContain.interactive = true
    },
    pointermove (e) {
      const currentTarget = e.currentTarget
      let { x, y } = e.data.global

      if (currentTarget.dragging) {
        if (x <= 0) x = 10
        if (x >= this.init_data.stageWidth) x = this.init_data.stageWidth - 10
        if (y >= this.init_data.stageHeight) y = this.init_data.stageHeight - 10
        if (y <= 0) y = 10
        currentTarget.x = (x - this.startX) / this.init_data.scale + (this.Model.spineData.width / 2 + this.boneX)
        currentTarget.y = (y - this.startY) / this.init_data.scale + (this.Model.spineData.height - this.boneY)
        this.activeBone.x = (x - this.startX) / this.init_data.scale + this.boneX
        this.activeBone.y = (-(y - this.startY) / this.init_data.scale + this.boneY)
      }
    },
    /** spine交互  结束 */
    /** 用户操作  开始 */
    async showExport () {
      const imageData = this.app.renderer.plugins.extract.pixels(this.Model)
      await this.clearSpace(imageData)
      this.$refs.exportPngModal.showModal()
    },
    clickPlace (item) {
      this.activeSlot = item
    },
    // 导出png
    exportImage ({ x, y }) {
      // const width = Math.round((this.personContain.width - this.Model.spineData.width * this.personContain.scale.x) / 2)
      // const height = Math.round((this.personContain.height - this.Model.spineData.height * this.personContain.scale.y) / 2)
      console.log(x, y)
      // const x = Math.round((this.personContain.x - this.personContain.width / 2) - (this.areaContain.x - this.areaContain._width / 2))
      // const y = Math.round((this.personContain.y - this.personContain.height / 2) - (this.areaContain.y - this.areaContain._height / 2))
      x = Math.round(x)
      y = Math.round(y)
      // this.debug()
      // 头部不用导出
      const ignoreArr = ['neck',
        'jewelry',
        'coat',
        'tie',
        'backAdornment',
        'chest',
        'waist',
        'bellyButton',
        'pelvis',
        'tail',
        'hindarmSleeve_L',
        'hindarmSleeve_R',
        'forearmSleeve_L',
        'forearmSleeve_R',
        'hindarm_L',
        'hindarm_R',
        'forearm_L',
        'forearm_R',
        'hand_L',
        'hand_R',
        'thumb_L_1',
        'thumb_L_2',
        'thumb_R_1',
        'thumb_R_2',
        'indexFinger_L_1',
        'indexFinger_L_2',
        'indexFinger_L_3',
        'indexFinger_R_1',
        'indexFinger_R_2',
        'indexFinger_R_3',
        'middleFinger_L_1',
        'middleFinger_L_2',
        'middleFinger_L_3',
        'middleFinger_R_1',
        'middleFinger_R_2',
        'middleFinger_R_3',
        'ringFinger_L_1',
        'ringFinger_L_2',
        'ringFinger_L_3',
        'ringFinger_R_1',
        'ringFinger_R_2',
        'ringFinger_R_3',
        'littleFinger_L_1',
        'littleFinger_L_2',
        'littleFinger_L_3',
        'littleFinger_R_1',
        'littleFinger_R_2',
        'littleFinger_R_3',
        'ring_L',
        'ring_R',
        'skirt_1',
        'skirt_2',
        'skirt_3',
        'skirt_4',
        'pants',
        'shoe_L',
        'shoe_R',
        'buttock',
        'hip',
        'leg_L',
        'leg_R',
        'thigh_L',
        'thigh_R',
        'calf_L',
        'calf_R',
        'foot_L',
        'foot_R',
        'heel_L',
        'heel_R',
        'sole_L',
        'sole_R',
        'toe_L',
        'toe_R']

      this.Model.skeleton.slots.forEach(item => {
        if (!ignoreArr.includes(item.data.name)) {
          this.Model.skeleton.findSlot(item.data.name).color.a = 0
        }
      })
      // let image = this.app.renderer.plugins.extract.base64(this.Model)
      const img = new Image()
      img.src = this.imageData
      img.onload = () => {
        const url = window.URL.createObjectURL(dataURLtoBlobs(this.imageData))
        const a = document.createElement('a')
        a.href = url
        // const width = Math.round(img.width / 4)
        const width = Math.round(img.width / 4)
        const height = Math.round(img.height / 4)
        a.download = `${this.packageInfo.character_name}_${this.direction[this.activeDirection].list[this.direction[this.activeDirection].activeAction].name}_${this.direction[this.activeDirection].name}_(${width}_${height}_${x}_${y}).png` // 这里填保存成的文件名
        a.click()
        URL.revokeObjectURL(a.href)
        a.remove()
        this.imageData = null
        this.spinning = false
        this.Model.skeleton.slots.forEach(item => {
          if (!ignoreArr.includes(item.data.name)) {
            this.Model.skeleton.findSlot(item.data.name).color.a = 1
          }
        })
      }
    },
    // 重新加载模型
    reloadModel () {
      this.personContain.removeChild(this.Model)
      this.Model = new PIXI.spine.Spine(this.app.loader.resources.model.spineData)
      this.loadModel()
      this.hackTextureBySlotName(this.slicesList)
    },
    // 选择动作
    chooseAction (index) {
      this.Model.state.tracks = []
      this.direction[this.activeDirection].activeAction = index
      if (this.direction[this.activeDirection].list[index].name === '初始') {
        this.reloadModel()
      } else {
        this.reloadModel()
        this.Model.state.setAnimation(0, this.direction[this.activeDirection].list[index].name, false)
      }
    },
    chooseDirection (index) {
      this.activeDirection = index
    },
    goHome () {
      this.$router.push('manage/person')
    },
    async clearSpace (imageData) {
      let { width, height } = this.Model

      width = Math.floor(width)
      height = Math.floor(height)
      let pos_t = height
      let pos_b = 0
      let pos_l = width
      let pos_r = 0
      // 逐个扫描找出四个方向 有像素的的坐标
      for (let i = 3; i < imageData.length; i += 4) {
        if (imageData[i] > 0) {
          pos_t = Math.min(pos_t, Math.ceil((i / 4) / width))
          pos_b = Math.max(pos_b, Math.ceil((i / 4) / width))
          pos_l = Math.min(pos_l, Math.ceil(i / 4) % width)
          pos_r = Math.max(pos_r, Math.ceil(i / 4) % width)
        }
      }

      const x = pos_l
      const y = pos_t
      const c_width = pos_r - pos_l
      const c_height = pos_b - pos_t
      const image = this.app.renderer.plugins.extract.base64(this.Model)
      await this.clipImage(image, { sWidth: width, sHeight: height, x, y, width: c_width, height: c_height }).then(res => {
        this.imageData = res
      })
    },
    clipImage (base64, { sWidth, sHeight, x, y, width, height }) {
      let canvas = document.createElement('canvas')
      var image = new Image()
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')
      image.src = base64
      image.crossOrigin = 'Anonymous'
      console.log(sWidth, sHeight, x, y, width, height)
      return new Promise((resolve, reject) => {
        image.onload = () => {
          ctx.drawImage(image, x, y, width, height, 0, 0, width, height)
          resolve(canvas.toDataURL())
          canvas = null
        }
      })
    }
    /** 用户操作  结束 */
  },
  destroyed () {
    window.removeEventListener('resize', this.resize, false)
  }
}
</script>

<style lang="less" scoped>

.export-modal{
  background-color: #5D5D5D;
  .export-content {
    width: 512px;
    height: 512px;
  }
}
.ant-spin-nested-loading {
  background-color: rgba(255, 255, 255, 0.3);
}
.spine-wrapper {
  position: relative;
  width: 100%;
  .header {
    background-color: #424242;
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      margin-left: 56px;

      .icon-logo {
        font-size: 142px;
        color: #FF7401;
      }
    }
    .action {
      margin-right: 25px;

    }
  }
  .editor-box {
    display: flex;
    height:calc(~"100vh - 64px") ;
    .left-side {
      width: 252px;
      background-color:#424242;
      box-sizing: border-box;
      border: 2px solid #333333;
      display: flex;
      flex-direction: column;
      .title{
        padding: 16px;
        color: #999999;
        font-size: 14px;
        background-color: #333333;
        line-height: 1;
      }
      .empty {
        display: flex;
        height: 100%;
        width: 100%;
        justify-content: center;
        align-items: center;
        span {
          font-size: 24px;
          color: #666666;
        }
      }
      .bone {
        flex: 1;
        display: flex;
        flex-direction: column;
        .bone_list {
          flex: 1;
        }
      }
      .action{
        flex: 1;
        display: flex;
        flex-direction: column;
        .nav {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #333333;
          .nav-item {
            color: #999999;
            font-size: 14px;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
             height: 40px;
            &:not(:last-child){
              border-right: 1px solid #333333;
            }
            span {
              display: block;
              width: 24px;
              height: 24px;
              background-color: #ffffff;
              border-radius: 2px;
              overflow: hidden;
              margin-left: 3px;
              img {
                width: 100%;
                height: 100%;
                display: block;
              }
            }
          }
        }
        .action_list  {
          flex: 1;
        }
      }
    }
    .editor {
      flex: 1;
      position: relative;
      width: calc(~"100vh - 504px");
      #spine{
        height: 100%;
        background-color: #5D5D5D;
      }
    }
    .right-side {
      width: 256px;
      box-sizing: border-box;

      background-color: #333333;
      .title {
        color: #999999;
        font-size: 14px;
        padding: 24px;
        line-height: 1;
        margin-bottom: 0;
      }
      .direction-list{
        display: flex;
        justify-content: space-between;
        padding:  0 24px 24px;
        span {
          display: block;
          padding: 7px 12px;
          line-height: 1;
          background-color: #484848;
          border-radius: 4px;
          cursor: pointer;
          color: #999999;
          &.active {
            background-color: #FFFFFF;
          }
          &.disabled {
            opacity: 0.5;
            pointer-events: none;
          }
          &:hover{
            background-color: #FFFFFF;
          }

        }
      }
      .action-list {

        display: flex;
        flex-wrap: wrap;
        justify-content:  space-between;
        align-items: flex-start;
        align-content: flex-start;
        box-sizing: border-box;
        padding: 0 8px 0 24px;
        height: calc(~"100vh - 202px");
        overflow: auto;
        margin-right: 16px;
        .action-item {
          width: 92px;
          height: 92px;
          background-color: #484848;
          border-radius: 8px;
          text-align: center;
          line-height: 92px;
          cursor: pointer;
          margin-bottom: 24px;
          border: 1px solid #484848;
          box-sizing: border-box;
          color: #999999;
          font-size: 14px;

          &.active {
            border: 1px solid #888888;
          }
        }
        &::-webkit-scrollbar-thumb {
          background: #666666;
          border-radius: 4px;
        }
      }
    }
  }
  .operation-box{
    position: absolute;
    right: 0;
    top: 0;
    margin-top: 24px;
    margin-right: 24px;
    width: 30%;
    overflow: auto;
    z-index: 99;
    .operation-btn {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      justify-items: center;
      .btn {
        margin-bottom: 25px;

      }
    }
    .upload-list{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: space-between;
    }
    .upload-item{
      width: 100px;
      height: 100px;
      margin-bottom: 48px;
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: block;
        max-width: 100%;
        max-height: 100%;

      }
    }
  }
}
</style>
